/* eslint-disable */
import { lazy } from "react";
import { USER_ROLE } from "constants.js";
import { DEFAULT_PATHS } from "config.js";
import path from "path-browserify";
import { na } from "formulajs";
import { components } from "react-select/dist/react-select.cjs.prod";

const dashboards = {
  analytic: lazy(() => import("views/dashboards/DashboardsAnalytic")),
};

const tenants = {
  index: lazy(() => import("views/dashboards/DashboardsAnalytic")),
  addNew: lazy(() => import("views/tenants/AddNewTenants")),
  List: lazy(() => import("views/tenants/TenantList")),
  OverDue: lazy(() => import("views/tenants/overdueReservation")),
  ExpectedArrivals: lazy(() => import("views/tenants/ExpectedArrivals")),
  ViewTenant: lazy(() => import("views/tenants/ViewTenants")),
  EditTenant: lazy(() => import("views/tenants/EditTenants")),
  InActiveTenants: lazy(() => import("views/tenants/InActiveTenants")),
  ActiveTenants: lazy(() => import("views/tenants/ActiveTenants")),
};

const Customers = {
  CustomerList: lazy(()=>import("views/Customers/CustomerList")),
  CustomerView: lazy(()=>import("views/Customers/CustomerView"))
}
const PasswordList = {
  PasswordList: lazy(()=>import("views/Passwords/PasswordList")),
}
const ApiKeys = {
  List: lazy(() => import("views/apikeys/ApiKeyList")),
};


const FoundLoss = {
  FoundLost: lazy(()=>import("views/LostFound/LostFound"))
}

const staff = {
  index: lazy(() => import("views/dashboards/DashboardsAnalytic")),
  addNew: lazy(() => import("views/staff/AddStaff")),
  List: lazy(() => import("views/staff/StaffList")),
  ViewList: lazy(() => import("views/staff/ViewStaff")),
  Edit: lazy(() => import("views/staff/EditStaff")),
};
const Group = {
  index: lazy(() => import("views/dashboards/DashboardsAnalytic")),
  addNew: lazy(() => import("views/Groups/AddGroup")),
  List: lazy(() => import("views/Groups/GroupList")),
  ViewList: lazy(() => import("views/Groups/GroupView")),
  Edit: lazy(() => import("views/Groups/EditGroup")),
};
const agent = {
  index: lazy(() => import("views/dashboards/DashboardsAnalytic")),
  addNew: lazy(() => import("views/agents/AddAgent")),
  List: lazy(() => import("views/agents/AgentsPage")),
  ViewList: lazy(() => import("views/agents/ViewAgent")),
  Edit: lazy(() => import("views/agents/EditAgent")),
};

//Bed
const bed = {
  BedList: lazy(() => import("views/rooms/BedList")),
};
const Extra = {
  PosList: lazy(() => import("views/Extra/ExtraList")),
  PosAdd: lazy(() => import("views/Extra/ExtrasPOS")),
};
//Facilities
const facility = {
  RoomFacilities: lazy(() => import("views/rooms/RoomFacilities")),
  FacilitiesAssignment: lazy(() => import("views/rooms/FacilitiesAssignment")),
};
//Sources
const source = {
  BookingTypeList: lazy(() => import("views/rooms/BookingType")),

  BookingSource: lazy(() => import("views/rooms/BookingSource")),
};

const rooms = {
  index: lazy(() => import("views/dashboards/DashboardsAnalytic")),
  addNew: lazy(() => import("views/rooms/AddNewRoom")),
  // List: lazy(() => import("views/rooms/RoomsList")),
  View: lazy(() => import("views/rooms/ViewRoom")),
  Edit: lazy(() => import("views/rooms/EditRoom")),
  // TenantsList: lazy(() => import("views/rooms/RoomTenantList")),
  FilledRooms: lazy(() => import("views/rooms/FilledRoom")),
  ReservedRoomsList: lazy(() => import("views/rooms/ReservedRoomsList")),
  VacantsRooms: lazy(() => import("views/rooms/VacantRooms")),
  RoomTypes: lazy(() => import("views/rooms/RoomsTypes")),
  RoomAssignment: lazy(() => import("views/rooms/RoomAssignment")),
  RoomManagement: lazy(() => import("views/rooms/RoomTabularView")),
};
const floors = {
  plan_list: lazy(() => import("views/floors/FloorPlanList")),
  floor_list: lazy(() => import("views/floors/FloorList")),
};
const RoomPackages = {
  addNew: lazy(() => import("views/packages/AddPackages")),
  list: lazy(() => import("views/packages/Packageslist")),
  view: lazy(() => import("views/packages/ViewPackage")),
  Edit: lazy(() => import("views/packages/EditPackage")),
};
const inventory = {
  index: lazy(() => import("views/dashboards/DashboardsAnalytic")),
  addNew: lazy(() => import("views/inventory/AddNewInventory")),
  List: lazy(() => import("views/inventory/InventoryList")),
  Edit: lazy(() => import("views/inventory/EditInventory")),
  ViewItem: lazy(() => import("views/inventory/ViewItem")),
  ListInventory : lazy(()=>import("views/inventory/Listinventory"))
};
const attendance = {
  index: lazy(() => import("views/attendance/AttendancePage")),
  manualAttendance: lazy(() => import("views/attendance/ManualAttendance")),
  markHoliday: lazy(() => import("views/holidays/MarkLeave")),
  leaveList: lazy(() => import("views/holidays/LeaveList")),
  EditLeave: lazy(() => import("views/holidays/EditLeave")),
  LeaveStatus: lazy(() => import("views/holidays/LeaveStatus")),
  AttendanceList: lazy(() => import("views/attendance/AttendanceList")),
  AttendanceListLeave: lazy(() => import("views/attendance/AttendanceLeave")),
  ViewSingleAttendanceList: lazy(() =>
    import("views/attendance/ViewSingleAttendancePage")
  ),
};
const accounts = {
  index: lazy(() => import("views/dashboards/DashboardsAnalytic")),
  List: lazy(() => import("views/accounts/AccountPage")),
  AddPO: lazy(() => import("views/supplier/AddNewPurchaseOrder")),
  Income: lazy(() => import("views/accounts/Income")),
  logsView: lazy(() => import("views/accounts/LogsView")),   
  Expenses: lazy(() => import("views/accounts/ExpensePage")),
  ViewExpenses: lazy(() => import("views/accounts/ExpenseView")),
  addNew: lazy(() => import("views/accounts/AddNewExpense")),
  EditExpense: lazy(() => import("views/accounts/EditExpense")),
  AddSupplier: lazy(()=>import("views/supplier/AddNewSupplier")),
  ViewSupplier: lazy(()=>import("views/supplier/ViewSupplier")),
  ViewPurchaseBill: lazy(()=>import("views/supplier/ViewPurchaseBill")),
  Supplier: lazy(()=>import("views/supplier/SupplierList")),
  PO: lazy(()=>import("views/supplier/PurchaseOrderList")),
  Purchasebill: lazy(()=>import("views/supplier/BillsList")),
  POView: lazy(()=>import("views/supplier/ViewPurchaseOrder")),
  POEdit: lazy(()=>import("views/supplier/EditPurchaseOrder")),
};
const organization = {
  index: lazy(() => import("./views/organization/OrganizationProfile")),
  payments: lazy(() => import("./views/organization/Payments")),
};
const announcements = {
  index: lazy(() => import("./views/announcements/AnnouncementsPage")),
};
const fees = {
  index: lazy(() => import("views/apps/Apps")),
  list: lazy(() => import("views/fee/FeeList")),
  ViewFee: lazy(() => import("views/fee/ViewFee")),
  ReceivedFee: lazy(() => import("views/fee/ReceivedFee")),
  ReceivableFee: lazy(() => import("views/fee/ReceivableFee")),
  PerkList: lazy(() => import("views/fee/Perks")),
};
const reports = {
  index: lazy(() => import("views/dashboards/DashboardsAnalytic")),
  list: lazy(() => import("views/reports/ReportsPage")),
  activeReservationlist: lazy(() => import("views/reports/ActiveReservationReport")),
  allReservationlist: lazy(() => import("views/reports/AllReservationReport")),
  StaffReport: lazy(() => import("views/reports/staffReport")),
  dailyLedger: lazy(() => import("views/reports/DailyReport")),
  ledgerReport: lazy(() => import("views/reports/LedgerReport")),
  ProfitandLossReport: lazy(() => import("views/reports/ProfitandLossReport")),
  ViewReport: lazy(() => import("views/reports/ViewReport")),
  ViewReportByStatus: lazy(() => import("views/reports/ReportsByStatus")),
};
const apps = {
  index: lazy(() => import("views/apps/Apps")),
  calendar: lazy(() => import("views/apps/calendar/Calendar")),
  chat: lazy(() => import("views/apps/chat/Chat")),
  contacts: lazy(() => import("views/apps/contacts/Contacts")),
  mailbox: lazy(() => import("views/apps/mailbox/Mailbox")),
  tasks: lazy(() => import("views/apps/tasks/Tasks")),
};
const auth = {
  login: lazy(() => import("views/pages/authentication/Login")),
  // forgotpassword: lazy(() => import('views/pages/authentication/Login')),
};
const setting = {
  profileSetting: lazy(() => import("views/profile/ProfileSetting")),
};

const appRoot = DEFAULT_PATHS.APP.endsWith("/")
  ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length)
  : DEFAULT_PATHS.APP;

const routesAndMenuItems = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/dashboard`,
      component: dashboards.analytic,
    },
    {
      path: `${appRoot}/login`,
      component: auth.login,
      label: "",
      icon: "",
      name: "login",
      parent: true,
    },
    {
      path: `${appRoot}/profile-setting`,
      component: setting.profileSetting,
      label: "",
      icon: "",
      name: "profile",
      parent: true,
    },
    {
      path: `${appRoot}/dashboard`,
      component: dashboards.analytic,
      label: "menu.dashboard",
      icon: "home",
    },
    {
      path: `${appRoot}/reservations`,
      label: "menu.reservations",
      parent: true,
      name: "tenants",
      icon: "book",
      component: dashboards.analytic,
      subs: [
        { path: "/add-new", label: "menu.addnewreservation", component: tenants.addNew },
        { path: "/list", label: "menu.viewall", component: tenants.List },
        { path: "/overdue", label: "", component: tenants.OverDue },
        { path: "/expectedArrivals", label: "", component: tenants.ExpectedArrivals },
        { path: "/active", label: "", component: tenants.ActiveTenants },
        { path: "/inactive", label: "", component: tenants.InActiveTenants },
        { path: "/view/:id", label: "", component: tenants.ViewTenant },
        { path: "/edit/:id", label: "", component: tenants.EditTenant },
      ],
    },
     //Rooms
    {
      path: `${appRoot}/rooms`,
      label: "menu.rooms",
      icon: "building",
      name: "rooms",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/list", label: "menu.rooms", component: rooms.addNew },
        { path: "/room-management", label: "menu.roomManagement", component: rooms.RoomManagement },
        { path: "/room-reserved", label: "", component: rooms.ReservedRoomsList },
        {
          path: "/room-types",
          label: "menu.RoomTypes",
          component: rooms.RoomTypes,
        },

        { path: "/filled", label: "", component: rooms.FilledRooms },
        { path: "/vacants", label: "", component: rooms.VacantsRooms },
        { path: "/view/:id", label: "", component: rooms.View },
        { path: "/edit/:id", label: "", component: rooms.Edit },
        { path: "/tenant/list/:id", label: "", component: rooms.TenantsList },
        {
          path: "/room-assigns",
          label: "menu.RoomAssignment",
          component: rooms.RoomAssignment,
        },
      ],
    },
     {
      path: `${appRoot}/floor`,
      label: "menu.floor",
      icon: "building-large",
      name: "floor",
      parent: true,
      component: dashboards.analytic,
      subs: [
        {
          path: "/plan-list",
          label: "menu.floorplanlist",
          component: floors.plan_list,
        },
        {
          path: "/floor-list",
          label: "menu.floorlist",
          component: floors.floor_list,
        },
      ],
    },

    {
      path: `${appRoot}/staff`,
      label: "menu.staff",
      icon: "user",
      name: "staff",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/add-new", label: "menu.addnew", component: staff.addNew },
        { path: "/list", label: "menu.list", component: staff.List },
        { path: "/view/:id", label: "", component: staff.ViewList },
        { path: "/edit/:id", label: "", component: staff.Edit },
      ],
    },
    {
      path: `${appRoot}/agent`,
      label: "menu.agent",
      icon: "web",
      name: "agent",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/add-new", label: "menu.addnew", component: agent.addNew },
        { path: "/list", label: "menu.list", component: agent.List },
        { path: "/view/:id", label: "", component: agent.ViewList },
        { path: "/edit/:id", label: "", component: agent.Edit },
      ],
    },

    {
      path: `${appRoot}/accounts`,
      label: "menu.accounts",
      icon: "laptop",
      parent: true,
      name: "accounts",
      component: dashboards.analytic,
      subs: [
        { path: "/expense/add-new", label: "", component: accounts.addNew },
        { path: "/add-supplier", label: "", component: accounts.AddSupplier },
        { path: "/view-supplier/:id", label: "", component: accounts.ViewSupplier },

        {
          path: "/expense",
          label: "menu.expenses",
          component: accounts.Expenses,
        },
        {
          path: "/suppliers",
          label: "menu.suppliers",
          component: accounts.Supplier,
        },
        {
          path: "/add-po",
          label: "",
          component: accounts.AddPO,
        },
        {
          path: "/po-view/:id",
          label: "",
          component: accounts.POView,
        },
        {
          path: "/po-edit/:id",
          label: "",
          component: accounts.POEdit,
        },
        {
          path: "/bill-view/:id",
          label: "",
          component: accounts.ViewPurchaseBill,
        },
        {
          path: "/list-po",
          label: "menu.poList",
          component: accounts.PO,
        },
        {
          path: "/list-bills",
          label: "menu.bills",
          component: accounts.Purchasebill,
        },
        {
          path: "/income",
          label: "menu.income",
          component: accounts.Income,
        },
        {
          path: "/logs/:id",
          label: "",
          component: accounts.logsView,
        },
        {
          path: "/view/:expenseId",
          label: "",
          component: accounts.ViewExpenses,
        },
        { path: "/edit/:id", label: "", component: accounts.EditExpense },
      ],
    },


    //Floors
   
   
    //Source
    // {
    //   path: `${appRoot}/source`,
    //   label: "Source",
    //   icon: "destination",
    //   name: "Source",
    //   parent: true,
    //   component: dashboards.analytic,
    //   subs: [
    //     {
    //       path: "/booking-type",
    //       label: "menu.bookingtype",
    //       component: source.BookingTypeList,
    //     },
    //     {
    //       path: "/booking-source",
    //       label: "menu.BookingSource",
    //       component: source.BookingSource,
    //     },
    //   ],
    // },
    //Beds
    {
      path: `${appRoot}/bed`,
      label: "menu.Bed",
      icon: "home",
      name: "Bed",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/bed-list", label: "menu.bedlist", component: bed.BedList },
      ],
    },
    //Facilities
    // {
    //   path: `${appRoot}/facilities`,
    //   label: "Facilities",
    //   icon: "plus",
    //   name: "Facility",
    //   parent: true,
    //   component: dashboards.analytic,
    //   subs: [
    //     {
    //       path: "/room-facilities",
    //       label: "menu.RoomFacilities",
    //       component: facility.RoomFacilities,
    //     },
    //     {
    //       path: "/facilities-assignment",
    //       label: "menu.FacilitiesAssignment",
    //       component: facility.FacilitiesAssignment,
    //     },
    //   ],
    // },

    //Packages
    // {
    //   path: `${appRoot}/package`,
    //   label: "menu.package",
    //   icon: "boxes",
    //   name: "package",
    //   parent: true,
    //   component: dashboards.analytic,
    //   subs: [
    //     {
    //       path: "/add-package",
    //       label: "Add New",
    //       component: RoomPackages.addNew,
    //     },
    //     { path: "/list", label: "List", component: RoomPackages.list },
    //     { path: "/view/:id", label: "", component: RoomPackages.view },
    //     { path: "/edit/:id", label: "", component: RoomPackages.Edit },
    //   ],
    // },
    {
      path: `${appRoot}/extra`,
      label: "menu.extra",
      icon: "duplicate",
      name: "extra",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/extra-list", label: "menu.extralist", component: Extra.PosList },
        { path: "/extra-pos", label: "menu.extrapos", component: Extra.PosAdd },
      ],
    },
    {
      path: `${appRoot}/passwords`,
      label: "menu.passwords",
      icon: "notebook-1",
      name: "passwords",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/password-list", label: "menu.passwords", component: PasswordList.PasswordList },
        // { path: "/extra-pos", label: "menu.extrapos", component: Extra.PosAdd },
      ],
    },
    {
      path: `${appRoot}/api-keys`,
      label: "",
      icon: "key",
      name: "api-keys",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/list", label: "", component: ApiKeys.List },
      ],
    },
    {
      path: `${appRoot}/groups`,
      label: "menu.groups",
      icon: "user",
      name: "groups",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/add-new", label: "menu.addnew", component: Group.addNew },
        { path: "/list", label: "menu.list", component: Group.List },
        { path: "/view/:id", label: "", component: Group.ViewList },
        { path: "/edit/:id", label: "", component: Group.Edit },
      ],
    },
    {
      path: `${appRoot}/customers`,
      label: "menu.customer",
      icon: "user",
      name: "customer",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/customer-list", label: "menu.customer", component: Customers.CustomerList },
        { path: "/customer-View/:id", label: "", component: Customers.CustomerView },
      ],
    },
    {
      path: `${appRoot}/Loss-found`,
      label: "menu.Lossfound",
      icon: "search",
      name: "Loss-found",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/Loss-found", label: "menu.Lossfound", component: FoundLoss.FoundLost },
      ],
    },
    // Inventory
    {
      path: `${appRoot}/inventory`,
      label: "menu.assets",
      icon: "invoice",
      name: "inventory",
      parent: true,
      component: dashboards.analytic,
      subs: [
        { path: "/add-new", label: "menu.addnew", component: inventory.addNew },
        { path: "/list-inventory", label: "menu.inventory", component: inventory.ListInventory },
        { path: "/list", label: "menu.assetlist", component: inventory.List },
        { path: "/view/item/:id", label: "", component: inventory.ViewItem },
        { path: "/edit/:id", label: "", component: inventory.Edit },
      ],
    },
    // {
    //   path: `${appRoot}/attendance`,
    //   label: "menu.attendance",
    //   icon: "online-class",
    //   name: "attendance",
    //   parent: true,
    //   component: dashboards.analytic,
    //   subs: [
    //     { path: "/list", label: "menu.list", component: attendance.index },
    //     {
    //       path: "/view/:status",
    //       label: "",
    //       component: attendance.AttendanceList,
    //     },
    //     {
    //       path: "/tenant/view/:id",
    //       label: "",
    //       component: attendance.ViewSingleAttendanceList,
    //     },
    //     {
    //       path: "/leave/list",
    //       label: "",
    //       component: attendance.AttendanceListLeave,
    //     },
    //     {
    //       path: "/mark-attendance",
    //       label: "menu.mark_attendance",
    //       component: attendance.manualAttendance,
    //     },
    //     { path: "/mark-leave", label: "", component: attendance.markHoliday },
    //     {
    //       path: "/leaves",
    //       label: "menu.leave_list",
    //       component: attendance.leaveList,
    //     },
    //     { path: "/leave/edit/:id", label: "", component: attendance.EditLeave },
    //     {
    //       path: "/leave/:status",
    //       label: "",
    //       component: attendance.LeaveStatus,
    //     },
    //   ],
    // },
    // {
    //   path: `${appRoot}/fee`,
    //   label: "menu.fee",
    //   icon: "dollar",
    //   name: "fees",
    //   parent: true,
    //   component: dashboards.analytic,
    //   subs: [
    //     { path: "/list", label: "menu.list", component: fees.list },
    //     { path: "/fee-perks", label: "menu.perks", component: fees.PerkList },
    //     { path: "/receivable-fee", label: "", component: fees.ReceivableFee },
    //     { path: "/received-fee", label: "", component: fees.ReceivedFee },
    //     { path: "/view/:id", label: "", component: fees.ViewFee },
    //   ],
    // },
    
    {
      path: `${appRoot}/organization`,
      label: "menu.organization",
      icon: "building-large",
      parent: true,
      name: "organization",
      component: organization.index,
      subs: [
        {
          path: "/profile",
          label: "menu.organization",
          component: organization.index,
        },
        // {
        //   path: "/payments",
        //   label: "menu.payments",
        //   component: organization.payments,
        // },
      ],
    },
    {
      path: `${appRoot}/push-notification`,
      label: "menu.announcements",
      icon: "bell",
      parent: true,
      name: "announcements",
      component: announcements.index,
    },
    {
      path: `${appRoot}/reports`,
      label: "menu.reports",
      icon: "duplicate",
      parent: true,
      name: "reports",
      component: dashboards.analytic,
      subs: [
        { path: "/list", label: "menu.listreports", component: reports.list },
        { path: "/active_reservations", label: "menu.activereservations", component: reports.activeReservationlist },
        { path: "/all_reservations", label: "menu.allreservations", component: reports.allReservationlist },
        { path: "/profitandloss", label: "menu.profitandloss", component: reports.ProfitandLossReport },
        { path: "/staffReport", label: "menu.staffReport", component: reports.StaffReport },
        { path: "/ledgerReport", label: "menu.ledgerReport", component: reports.ledgerReport },
        { path: "/dailyledger", label: "", component: reports.dailyLedger },
        { path: "/view/:id", label: "", component: reports.ViewReport },
        {
          path: "/type/:type",
          label: "",
          component: reports.ViewReportByStatus,
        },
      ],
    },
  ],
  sidebarItems: [
    {
      path: "#connections",
      label: "menu.connections",
      icon: "diagram-1",
      hideInRoute: true,
    },
    {
      path: "#bookmarks",
      label: "menu.bookmarks",
      icon: "bookmark",
      hideInRoute: true,
    },
    {
      path: "#requests",
      label: "menu.requests",
      icon: "diagram-2",
      hideInRoute: true,
    },
    {
      path: "#account",
      label: "menu.account",
      icon: "user",
      hideInRoute: true,
      subs: [
        {
          path: "/settings",
          label: "menu.settings",
          icon: "gear",
          hideInRoute: true,
        },
        {
          path: "/password",
          label: "menu.password",
          icon: "lock-off",
          hideInRoute: true,
        },
        {
          path: "/devices",
          label: "menu.devices",
          icon: "mobile",
          hideInRoute: true,
        },
      ],
    },
    {
      path: "#notifications",
      label: "menu.notifications",
      icon: "notification",
      hideInRoute: true,
      subs: [
        {
          path: "/email",
          label: "menu.email",
          icon: "email",
          hideInRoute: true,
        },
        { path: "/sms", label: "menu.sms", icon: "message", hideInRoute: true },
      ],
    },
    {
      path: "#downloads",
      label: "menu.downloads",
      icon: "download",
      hideInRoute: true,
      subs: [
        {
          path: "/documents",
          label: "menu.documents",
          icon: "file-text",
          hideInRoute: true,
        },
        {
          path: "/images",
          label: "menu.images",
          icon: "file-image",
          hideInRoute: true,
        },
        {
          path: "/videos",
          label: "menu.videos",
          icon: "file-video",
          hideInRoute: true,
        },
      ],
    },
  ],
};
export default routesAndMenuItems;
